import { Bar, BarChart, Cell, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { money } from "../../lib/dash";
import { day } from "./AdsWindows";

const BAR = "hsl(var(--accent-strong))";

const DayTip = ({ active, payload, currency }) => {
  if (!active || !payload?.length) return null;
  const d = payload[0].payload;
  return (
    <div className="rounded-lg border border-border bg-card px-2.5 py-1.5 text-[11.5px] shadow-md">
      <p className="font-semibold">{day(d.date, { weekday: "short", month: "short", day: "numeric" })}{d.partial ? " · so far" : ""}</p>
      <p className="tabular-nums">{money(d.spend, currency)}</p>
    </div>
  );
};

// Tile 13's 30-day chart: one bar per ad-account local day; today (the last bar) is partial, drawn hollow.
export const AdsDailyChart = ({ daily }) => {
  const today = daily.days[daily.days.length - 1];
  return (
    <div data-testid="ads-daily" data-days={daily.days.length} className="flex min-h-0 flex-col">
      <div className="flex items-baseline justify-between gap-2">
        <p className="font-mono2 text-[10px] uppercase tracking-[0.16em] text-muted-foreground">Daily spend · 30 days</p>
        <p data-testid="ads-daily-total" className="truncate text-[11.5px] tabular-nums text-muted-foreground">
          <b className="text-foreground">{money(daily.total, daily.currency)}</b> · {money(daily.average, daily.currency)} a day
        </p>
      </div>
      <div className="mt-1 min-h-[120px] flex-1">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={daily.days} margin={{ top: 6, right: 16, bottom: 0, left: 16 }} barCategoryGap="18%">
            <XAxis dataKey="date" tickFormatter={(d) => day(d)} interval={6} tick={{ fontSize: 10, fill: "hsl(var(--muted-foreground))" }}
              axisLine={false} tickLine={false} />
            <YAxis hide domain={[0, "dataMax"]} />
            <Tooltip content={<DayTip currency={daily.currency} />} cursor={{ fill: "hsl(var(--muted))" }} />
            <Bar dataKey="spend" radius={[3, 3, 0, 0]} isAnimationActive={false}>
              {daily.days.map((d) => (
                <Cell key={d.date} fill={BAR} fillOpacity={d.partial ? 0.25 : 0.85} stroke={d.partial ? BAR : "none"} strokeDasharray="3 2" />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
      <p data-testid="ads-daily-today" className="mt-1 truncate text-[11px] text-muted-foreground">
        Last bar = today ({day(today.date)}), so far: {money(today.spend, daily.currency)}. Provisional: Meta can revise up to 28 days back.
      </p>
    </div>
  );
};
